import styled from "styled-components";
import { Box, darken, lighten } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

export const CurtainEntranceWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	position: absolute;
	z-index: 3;
	width: 100%;
	max-width: 430px;
	height: 100vh;
	overflow: hidden;
	box-sizing: border-box;
	transition: opacity 1.2s ease-in-out 2.4s;
	background: ${props => props.colormatrix.entrance.background};

	&.show {
		opacity: 1;
		cursor: pointer;
	}

	&.hide {
		opacity: 0;
		z-index: -1;
		cursor: unset;
	}

	&.preview {
		position: relative;
		max-width: 320px;
		height: 600px;
		border-radius: 16px;
		margin: 0 auto;
		cursor: default;
	}

	.stage {
		position: absolute;
		inset: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 0;
	}

	.couples_banner {
		max-width: 300px;
		padding: 25px;
		text-align: center;

		p {
			text-align: center;
			color: ${props => darken(props.colormatrix.entrance.envelope_background, 0.55)};
		}

		.wedding_of {
			font-family: var(--roboto), sans-serif;
			font-size: 18px;
		}

		.couples {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 26px;
		}
	}

	.curtain_rod {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 12px;
		z-index: 4;
		background: linear-gradient(
			180deg,
			${props => lighten(props.colormatrix.main, 0.3)},
			${props => darken(props.colormatrix.main, 0.4)}
		);
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.35);
	}

	.valance {
		position: absolute;
		top: 8px;
		left: 0;
		width: 100%;
		height: 70px;
		z-index: 4;
		pointer-events: none;
		filter: drop-shadow(0 6px 6px rgba(0, 0, 0, 0.35));

		.valance_shape {
			fill: ${props => darken(props.colormatrix.entrance.envelope_background, 0.1)};
		}
	}

	.couples_banner .wedding_of,
	.couples_banner .couples {
		opacity: 0;
	}

	&.opened .wedding_of {
		animation: name_drop 1s ease-out 0.5s forwards;
	}

	&.opened .groom {
		animation: name_from_start 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.8s forwards;
	}

	&.opened .and {
		animation: name_pop 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) 1.1s forwards;
	}

	&.opened .bride {
		animation: name_from_end 1.1s cubic-bezier(0.22, 1, 0.36, 1) 1.4s forwards;
	}

	&.opened .couples_banner {
		animation: names_glow 2.5s ease-in-out 2.4s infinite;
	}

	.curtains {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
		filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.5));
	}

	.tab_continue_container {
		position: absolute;
		bottom: 12%;
		left: 0;
		right: 0;
		z-index: 4;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;

		.tab_continue {
			background: rgba(255, 255, 255, 0.85);
			box-shadow: 0 0 8px 1px ${props => darken(props.colormatrix.main, 0.3)};
			border-radius: 50px;
			padding: 20px;

			svg {
				fill: ${props => darken(props.colormatrix.main, 0.3)};
			}
		}

		.tab_continue_text {
			font-family: var(--poppins), sans-serif;
			font-weight: bold;
			color: #fff;
			text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
		}
	}

	@keyframes name_drop {
		from {
			opacity: 0;
			transform: translateY(-14px);
			letter-spacing: 6px;
		}
		to {
			opacity: 1;
			transform: translateY(0);
			letter-spacing: normal;
		}
	}

	@keyframes name_from_start {
		from {
			opacity: 0;
			transform: translateX(-40px) scale(0.9);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
			filter: blur(0);
		}
	}

	@keyframes name_from_end {
		from {
			opacity: 0;
			transform: translateX(40px) scale(0.9);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
			filter: blur(0);
		}
	}

	@keyframes name_pop {
		from {
			opacity: 0;
			transform: scale(0.2) rotate(-20deg);
		}
		to {
			opacity: 1;
			transform: scale(1) rotate(0);
		}
	}

	@keyframes names_glow {
		0%,
		100% {
			text-shadow: none;
		}
		50% {
			text-shadow: 0 0 14px rgba(255, 255, 255, 0.9);
		}
	}
`;
